import { Duration, parse } from "tinyduration";

/**
 * Structural superset of tinyduration's `Duration` and the backend's
 * `RelativeDeltaModel` (whose fields are nullable). Only truthy numeric fields
 * are read, so either shape works.
 */
export type DurationLike = {
  years?: number | null;
  months?: number | null;
  weeks?: number | null;
  days?: number | null;
  hours?: number | null;
  minutes?: number | null;
  seconds?: number | null;
};

export function formatDuration(value: DurationLike | null | undefined): string {
  if (!value) return "";
  const parts: string[] = [];
  if (value.years) parts.push(`${value.years}y`);
  if (value.months) parts.push(`${value.months}mo`);
  if (value.weeks) parts.push(`${value.weeks}w`);
  if (value.days) parts.push(`${value.days}d`);
  if (value.hours) parts.push(`${value.hours}h`);
  if (value.minutes) parts.push(`${value.minutes}min`);
  if (value.seconds) parts.push(`${value.seconds}s`);
  return parts.join(" ");
}

export function parseDuration(
  value: string | null | undefined,
): Duration | null {
  if (!value) return null;
  try {
    return parse(value);
  } catch {
    return null;
  }
}

export { serialize as serializeDuration } from "tinyduration";
